/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Archive({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M4.487 6.475A.53.53 0 0 0 3.95 7c0 .29.24.525.538.525h5.385A.53.53 0 0 0 10.41 7a.53.53 0 0 0-.538-.525z" /><path fill="currentColor" fillRule="evenodd" d="M14 3.5c0 .588-.371 1.09-.897 1.298V10.5c0 1.257-1.045 2.275-2.334 2.275H3.59c-1.288 0-2.333-1.018-2.333-2.275V4.798A1.4 1.4 0 0 1 .36 3.5v-.875c0-.773.643-1.4 1.436-1.4h10.77c.792 0 1.435.627 1.435 1.4zm-12.205.35h10.77a.355.355 0 0 0 .358-.35v-.875c0-.193-.16-.35-.359-.35H1.794a.355.355 0 0 0-.358.35V3.5c0 .193.16.35.359.35m10.23 6.65V4.9H2.334v5.6c0 .677.563 1.225 1.257 1.225h7.18c.693 0 1.256-.548 1.256-1.225" clipRule="evenodd" /></svg>;
}
;